import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import { Text } from '../Text';
import { StyledError, StyledInput, StyledInputWrapper, StyledLabel, StyledLabelRequired, StyledWrapper, } from './Input.style';
import { InputAddonsAfter } from './InputAddonsAfter';
import { InputNumberControllers } from './InputNumber';
const getExtensions = (props) => {
    const { type, dropdownOptions } = props;
    const extensionArray = [];
    if (type === 'number') {
        extensionArray.push('number-controller');
    }
    if (Array.isArray(dropdownOptions) && dropdownOptions.length > 0) {
        extensionArray.push('addons-after');
    }
    return extensionArray;
};
export const Input = React.forwardRef(function Input(props, ref) {
    const { id, type = 'text', name, size = 'Medium', value, min, max, step, autocomplete = false, onBlur, onClick, onChange, onFocus, disabled, placeholder, className, label = '', errorMessage = '', dropdownOptions = [], onKeyDown, autofocus = false, readOnly = false, } = props;
    const [inputValue, setInputValue] = useState(value !== undefined && value !== null ? String(value) : '');
    const theme = useTheme();
    const inputRef = useRef(null);
    const extensions = getExtensions(props);
    const onChangeHandler = (event) => {
        let value = event.target.value;
        if (!Number.isNaN(min) && Number(value) < Number(min)) {
            value = String(min);
        }
        else if (!Number.isNaN(max) && Number(value) > Number(max)) {
            value = String(max);
        }
        setInputValue(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    const handleSelect = (value) => {
        setInputValue(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    useEffect(() => {
        setInputValue(value !== undefined && value !== null ? String(value) : '');
    }, [value]);
    return (_jsxs(StyledWrapper, { children: [label && (_jsx(StyledLabel, { htmlFor: id, children: _jsxs(Text, { size: theme.Form.Input.Size, showTooltip: true, children: [label, props.required && _jsx(StyledLabelRequired, { children: " *" })] }) })), _jsxs(StyledInputWrapper, { inputSize: size, children: [_jsx(StyledInput, { id: id, ref: ref !== null && ref !== void 0 ? ref : inputRef, type: type, name: name, min: min, max: max, step: step, inputSize: size, className: className, value: inputValue, placeholder: placeholder, disabled: disabled, onBlur: onBlur, onFocus: onFocus, onChange: onChangeHandler, extensions: extensions, autoComplete: autocomplete ? 'on' : 'off', "aria-autocomplete": autocomplete ? 'list' : 'none', isError: !!errorMessage, onKeyDown: onKeyDown, autoFocus: autofocus, onClick: (event) => onClick === null || onClick === void 0 ? void 0 : onClick(event), readOnly: readOnly }), type === 'number' && (_jsx(InputNumberControllers, { inputRef: (ref !== null && ref !== void 0 ? ref : inputRef), disabled: disabled })), dropdownOptions.length > 0 && (_jsx(InputAddonsAfter, { dropdownOptions: dropdownOptions, onSelect: (value) => handleSelect(inputValue + value) }))] }), errorMessage && (_jsx(StyledError, { children: _jsx(Text, { size: 'Small', color: theme.Color.Feedback.Alert, showTooltip: true, children: errorMessage }) }))] }));
});
//# sourceMappingURL=Input.js.map